var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "app-modal",
    {
      staticClass: "modalModelo",
      attrs: { titulo: _vm.titulo, width: 1100 },
      on: {
        closeModal: function($event) {
          return _vm.$emit("closeModal")
        }
      }
    },
    [
      _c(
        "template",
        { slot: "body" },
        [
          _vm.modelo.tipoModelo === "Modelo de Título Reurb"
            ? [
                _c("div", { staticClass: "campo-filtro-reurb" }, [
                  _c(
                    "div",
                    [
                      _c("p", [_vm._v("Município:")]),
                      _c(
                        "el-select",
                        {
                          staticClass: "full-width input",
                          attrs: {
                            value: _vm.modelo.idMunicipio,
                            placeholder: "Selecione o município",
                            disabled: "disabled"
                          }
                        },
                        _vm._l(_vm.municipiosComSelecionado, function(
                          municipio
                        ) {
                          return _c("el-option", {
                            key: municipio.id,
                            attrs: {
                              label: municipio.nome,
                              value: municipio.id
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "input-reurb" },
                    [
                      _c("p", [_vm._v("Reurb Coletivo:")]),
                      _c(
                        "el-select",
                        {
                          staticClass: "full-width input",
                          attrs: {
                            value: _vm.modelo.idReurbColetivo,
                            placeholder: "Selecione o Reurb Coletivo",
                            disabled: "disabled"
                          }
                        },
                        _vm._l(_vm.reurbColetivosComSelecionado, function(
                          reurb
                        ) {
                          return _c("el-option", {
                            key: reurb.id,
                            attrs: {
                              label:
                                reurb.numeroProcesso +
                                " - " +
                                reurb.nomeRazaoSocialInteressado,
                              value: reurb.id
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    [
                      _c("p", [_vm._v("Tipo Reurb:")]),
                      _c(
                        "el-select",
                        {
                          staticClass: "full-width input",
                          attrs: {
                            value: _vm.tipoReurbFormatado,
                            placeholder: "Selecione o tipo",
                            disabled: "disabled"
                          }
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "REURB S", value: "REURB_S" }
                          }),
                          _c("el-option", {
                            attrs: { label: "REURB E", value: "REURB_E" }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _c("div", { staticClass: "group mt-1" })
              ]
            : _vm._e(),
          _c("div", { staticClass: "group" }, [
            _c("p", { staticClass: "label-text" }, [
              _vm._v(
                _vm._s(
                  _vm.modelo.tipoModelo === "Modelo de Título Reurb"
                    ? "Modelo de Título"
                    : "Despacho"
                ) + ":"
              )
            ]),
            _c("div", {
              staticClass: "container",
              domProps: { innerHTML: _vm._s(_vm.modelo.textoModelo) }
            })
          ]),
          _vm.modelo.tipoModelo === "Modelo de Título Reurb" &&
          _vm.imagensAssinaturas.length > 0
            ? _c(
                "div",
                { staticClass: "group" },
                [
                  _c("p", { staticClass: "label-text" }, [
                    _vm._v("Assinaturas: ")
                  ]),
                  _c("app-anexo", {
                    staticClass: "container",
                    attrs: {
                      files: _vm.imagensAssinaturas,
                      id: "visualizar-assinaturas-modelo",
                      fileType: ["png", "jpg", "jpeg"],
                      exibirDownload: true,
                      exibirDelete: false,
                      showUpload: false
                    },
                    on: {
                      downloadDocumentoCadastro: _vm.downloadDocumentoCadastro
                    }
                  })
                ],
                1
              )
            : _vm._e()
        ],
        2
      ),
      _vm.ativaBotaoVoltar
        ? _c(
            "template",
            { slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      return _vm.$emit("closeModal")
                    }
                  }
                },
                [
                  _c("i", { staticClass: "el-icon-arrow-left" }),
                  _vm._v(" Voltar")
                ]
              )
            ],
            1
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d5caf6e0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d5caf6e0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/analise/components/AppModalVisualizarModelo.vue
// module id = null
// module chunks = 